import { EPlanName } from '@albacross/types'

export const paymentMethodOpts = Object.entries({
  card: 'Card',
  invoice: 'Invoice',
  agency_account: 'Agency account',
  other: 'Other',
}).map(([value, label]) => ({ value, label }))

const PLG_PLANS = [EPlanName.PlgStarter, EPlanName.PlgProfessional]
const SLG_PLANS = [EPlanName.SlgStarter, EPlanName.SlgProfessional, EPlanName.SlgOrganisation]

export const isSlgPlan = (planName: any) => {
  return SLG_PLANS.includes(planName)
}

export const isPlgPlan = (planName: any) => {
  return PLG_PLANS.includes(planName)
}
